import React, { useState } from 'react'
import { Field } from 'react-final-form'
import { makeStyles } from '@material-ui/core/styles'
import clsx from 'clsx'
import { CustomTextField } from './CustomDisabledFields'
import { Typography, IconButton, Collapse, Grid } from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import ReactHtmlParser from 'react-html-parser'

const useStyles = makeStyles(theme => ({
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest
    })
  },
  expandOpen: {
    transform: 'rotate(180deg)'
  }
}))

const ObservacaoField = ({ value, title, name, placeholder, disabled }) => {
  const classes = useStyles()
  const [expanded, setExpanded] = useState(true)

  const formatedValues =
    typeof value === 'string'
      ? ReactHtmlParser(value.replace(/(?:\r\n|\r|\n)/g, '<br>'))
      : value
  return (
    <>
      <Grid item xs={12}>
        <Typography variant="h6" gutterBottom>
          {title}
          <IconButton
            className={clsx(classes.expand, {
              [classes.expandOpen]: expanded
            })}
            onClick={() => setExpanded(!expanded)}
            aria-expanded={expanded}
          >
            <ExpandMoreIcon />
          </IconButton>
        </Typography>
        <Collapse in={expanded} timeout="auto" unmountOnExit>
          {formatedValues}
        </Collapse>
      </Grid>
      <Grid item xs={12}>
        <Field
          parse={val => (val == null ? '' : val)}
          disabled={disabled}
          fullWidth
          multiline
          rows={5}
          component={CustomTextField}
          placeholder={placeholder}
          name={name}
        />
      </Grid>
    </>
  )
}

export default React.memo(ObservacaoField)
